<div class="alerts">
    <div class="alerts-header">
        <h4>Alerts</h4>
        <button class="close-alerts" type="button" aria-label="Close alerts" (click)="onCloseClick()">&times;</button>
    </div>
    <div class="alerts-body">
        <div class="filters" *ngIf="!isLoading">
            <div class="filter-row">
                <label class="control search">
                    <span>Search</span>
                    <input type="text" [(ngModel)]="searchTerm" (input)="filterAlerts()" placeholder="Search alerts">
                </label>
                <label class="control" *ngIf="isManager">
                    <span>Location</span>
                    <select [(ngModel)]="selectedLocationId" (change)="onLocationChange()">
                        <option value="all">All locations</option>
                        <option *ngFor="let location of locations" [value]="location.reference">{{ location.label }}</option>
                    </select>
                </label>
                <label class="control" *ngIf="isManager">
                    <span>Assignee</span>
                    <select [(ngModel)]="selectedAssigneeId" (change)="onAssigneeChange()">
                        <option value="all">All assignees</option>
                        <option *ngFor="let assignee of assignees" [value]="assignee.id">{{ assignee.name }}</option>
                    </select>
                </label>
                <label class="control">
                    <span>Unread</span>
                    <select [(ngModel)]="selectedUnreadType" (change)="onUnreadTypeChange()">
                        <option value="all">All unread</option>
                        <option value="email">Unread emails ({{ emailCount }})</option>
                        <option value="message">Unread SMS ({{ smsCount }})</option>
                        <option value="missed_calls">Missed calls ({{ missedCallCount }})</option>
                    </select>
                </label>
            </div>
            <div class="filter-row filter-actions">
                <div class="type-toggles" aria-label="Alert types">
                    <label class="filter-chip select-all-chip" [class.active]="allAlertTypesSelected">
                        <input
                            #allAlertTypes
                            type="checkbox"
                            [checked]="allAlertTypesSelected"
                            (change)="toggleAllAlertTypes(allAlertTypes.checked)"
                        >
                        Select all
                    </label>
                    <label class="filter-chip" [class.active]="showOpportunities">
                        <input type="checkbox" [(ngModel)]="showOpportunities" (change)="filterAlerts()"> Opps ({{ opportunityCount }})
                    </label>
                    <label class="filter-chip" [class.active]="showLeases">
                        <input type="checkbox" [(ngModel)]="showLeases" (change)="filterAlerts()"> Leases ({{ leaseCount }})
                    </label>
                    <label class="filter-chip" [class.active]="showUnassignedOpps">
                        <input type="checkbox" [(ngModel)]="showUnassignedOpps" (change)="filterAlerts()"> Unassigned Opps ({{ unassignedOppCount }})
                    </label>
                </div>
                <button class="mark-read" type="button" (click)="markAllRead()" [disabled]="isMarkingRead || alerts.length === 0">
                    {{ isMarkingRead ? 'Marking...' : 'Mark all as read' }}
                </button>
            </div>
        </div>
        <div class="alerts-loading" *ngIf="isLoading">
            <div class="spinner"></div>
            <p>Loading alerts...</p>
        </div>
        <ul class="grid-list" *ngIf="!isLoading">
            <li *ngFor="let alert of filteredAlerts" (click)="onAlertClick(alert)">
                <h5>{{ alert.message }}</h5>
                <h6 *ngIf="isManager && alert?.user">Assignee: {{alert.user.first_name}} {{alert.user.last_name}}</h6>
                <h6 class="location-name" *ngIf="isManager && alert?.location">{{ alert.location.label }}</h6>
                <p>{{ alert.created_at }} <ion-icon *ngIf="alert.type=='email'" name="mail-open"></ion-icon><ion-icon *ngIf="alert.type=='message'" name="chatbubble"></ion-icon><span class="circle" *ngIf="!alert?.read"></span></p>
            </li>
        </ul>
    </div>
</div>
<div class="button" (click)="onViewAllClick()">
    VIEW ALL ALERTS
</div>
